import { useState } from "react";
import { Lightbulb, X } from "lucide-react";

export function TipBanner({ id, text }) {
  const key = `molaroo_tip_${id}`;
  const [hidden, setHidden] = useState(() => localStorage.getItem(key) === "1");
  if (hidden) return null;
  const dismiss = () => { localStorage.setItem(key, "1"); setHidden(true); };
  return (
    <div className="mx-5 mb-4 flex items-start gap-3 rounded-2xl bg-[#E6F4F1] border border-[#0D786A]/15 p-4 df-fade-in"
      data-testid={`tip-${id}`}>
      <span className="h-8 w-8 rounded-full bg-white text-[#0D786A] flex items-center justify-center shrink-0">
        <Lightbulb size={16} />
      </span>
      <p className="flex-1 text-sm text-slate-700 leading-relaxed">{text}</p>
      <button data-testid={`tip-${id}-dismiss`} onClick={dismiss}
        className="h-7 w-7 rounded-full hover:bg-white/70 text-slate-400 flex items-center justify-center shrink-0 df-pressable">
        <X size={15} />
      </button>
    </div>
  );
}
